import React from "react";
import PropTypes from "prop-types";
import withStyles from "react-jss";
import { setDisplayName } from "recompose";
import { LazyImage } from "react-lazy-images";

const styles = theme => ({
    root: {
        display: "flex",
        padding: "21px 0",
        borderBottom: "1px solid #d3cee1",
        alignItems: "center",
        justifyContent: "space-between",
    },
    firstHalf: {
        width: "600px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        textAlign: "center",
    },
    prov: {
        width: "250px",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        fontFamily: theme.fonts.medium,
        fontSize: "16px",
        lineHeight: "1",
        color: theme.palette.colors.darkSlateBlue,
    },
    logoWrapper: {
        width: "75px",
        marginRight: "25px",
    },
    logo: {
        maxWidth: "100%",
        height: "24px",
    },
    providerName: {
        width: "150px",
        textAlign: "left",
        wordWrap: "break-word",
        "& > a": {
            color: theme.palette.colors.darkSlateBlue,
        },
    },
    tariff: {
        width: "120px",
        textAlign: "center",
        fontFamily: theme.fonts.medium,
        fontSize: "16px",
        lineHeight: "1",
        color: theme.palette.colors.headerColour,
        display: "inline-block",
        verticalAlign: "bottom",
        "& > a": {
            color: theme.palette.colors.darkSlateBlue,
        },
    },
    noInformation: {
        width: "120px",
        textAlign: "center",
        fontFamily: theme.fonts.medium,
        fontSize: "16px",
        lineHeight: "1",
        color: theme.palette.colors.oneMoreGrey,
        display: "inline-block",
        verticalAlign: "bottom",
        "& > a": {
            color: theme.palette.colors.darkSlateBlue,
        },
    },
    rating: {
        width: "150px",
        textAlign: "center",
        fontFamily: theme.fonts.medium,
        fontSize: "16px",
        lineHeight: "1",
        color: theme.palette.colors.headerColour,
        display: "inline-block",
        verticalAlign: "bottom",
    },
    secondHalf: {
        width: "300px",
        display: "flex",
        justifyContent: "center",
    },
    smiles: {
        width: "150px",
        display: "flex",
        justifyContent: "space-around",
        // marginRight: "20px",
        "& > div": {
            width: "50px",
            textAlign: "center",
            fontFamily: theme.fonts.medium,
            fontSize: "16px",
            lineHeight: "1",
        },
        "& > div:nth-child(1)": {
            marginLeft: "auto",
            color: theme.palette.colors.oneMoreGreen,
        },
        "& > div:nth-child(2)": {
            color: theme.palette.colors.oneMoreGrey,
        },
        "& > div:nth-child(3)": {
            marginRight: "auto",
            color: "#fd5b72",
        },
    },
    reviews: {
        width: "75px",
        textAlign: "center",
        // paddingLeft: "40px",
        // marginRight: "20px",
        fontFamily: theme.fonts.medium,
        fontSize: "16px",
        lineHeight: "1",
        color: theme.palette.colors.oneMoreGrey,
    },
    comments: {
        width: "75px",
        textAlign: "center",
        // paddingLeft: "10px",
        fontFamily: theme.fonts.medium,
        fontSize: "16px",
        lineHeight: "1",
        color: theme.palette.colors.oneMoreGrey,
    },
    button: {
        width: "180px",
    },
    [`@media (min-width: ${theme.media.md}) and (max-width: ${theme.media.lg})`]: {
        rating: {
            width: "90px",
        },
        firstHalf: {
            width: "450px",
        },
        prov: {
            width: "240px",
        },
        providerName: {
            width: "140px",
        },
        secondHalf: {
            width: "150px",
        },
        smiles: {
            width: "150px",
            marginRight: "0px",
            "& > div": {
                width: "50px",
            },
        },
        reviews: {
            display: "none",
            width: "100px",
            paddingLeft: "60px",
            marginRight: "0",
        },
        comments: {
            display: "none",
            width: "110px",
            paddingLeft: "60px",
        },
        button: {
            width: "180px",
        },
    },
    [`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
        root: {
            marginBottom: "9px",
        },
        firstHalf: {
            width: "350px",
        },
        logoWrapper: {
            marginRight: "10px",
        },
        prov: {
            width: "180px",
        },
        providerName: {
            width: "95px",
        },
        tariff: {
            width: "65px",
            fontSize: "14px",
        },
        noInformation: {
            width: "65px",
            fontSize: "14px",
        },
        rating: {
            width: "80px",
            fontSize: "14px",
        },
        secondHalf: {
            width: "126px",
        },
        smiles: {
            width: "126px",
            marginRight: "0px",
            "& > div": {
                width: "42px",
                fontSize: "14px",
            },
        },
        reviews: {
            display: "none",
            width: "100px",
            paddingLeft: "60px",
            marginRight: "0",
        },
        comments: {
            display: "none",
            width: "80px",
            paddingLeft: "30px",
        },
        button: {
            width: "165px",
        },
    },
    [`@media (max-width: ${theme.media.sm})`]: {
        root: {
            marginBottom: "9px",
        },
        firstHalf: {
            width: "50%",
            minWidth: "255px",
            flexGrow: "2",
        },
        rating: {
            width: "20%",
            textAlign: "right",
        },
        secondHalf: {
            width: "50%",
            flexGrow: "1",
            paddingLeft: "8.33%",
        },
        smiles: {
            width: "100%",
            display: "flex",
            marginRight: "0px",
            "& > div": {
                width: "33%",
            },
        },
        reviews: {
            display: "none",
        },
        comments: {
            display: "none",
        },
    },
    "@media (max-width: 520px)": {
        firstHalf: {
            width: "100%",
            minWidth: "0",
            flexGrow: "2",
        },
        rating: {
            width: "20%",
            textAlign: "right",
        },
        secondHalf: {
            display: "none",
        },
    },
});
const RowRating = ({
    classes,
    pos,
    logo,
    providerName,
    name,
    tariffLink,
    tariffCount,
    rating,
    positive,
    neutral,
    negative,
    button,
    reviews,
    comments,
    noInformation,
}) => {
    return (
        <div className={classes.root}>
            <div className={classes.firstHalf}>
                <div className={classes.prov}>
                    {/*<span> {pos} </span>*/}
                    {!!logo && (<div className={classes.logoWrapper}>
                        <LazyImage
                            src={logo}
                            placeholder={({ ref }) => (
                                <img
                                    ref={ref}
                                    className={classes.logo}
                                    alt={providerName}
                                />
                            )}
                            actual={({ imageProps }) => (
                                <img
                                    {...imageProps}
                                    className={classes.logo}
                                    alt={providerName}
                                />
                            )}
                        />
                    </div>)}
                    <div className={classes.providerName}>{name}</div>
                </div>
                {!!tariffCount ? (
                    <div className={classes.tariff}>{tariffLink}</div>
                ) : (
                    <div className={classes.noInformation}>{noInformation}</div>
                )}
                <div className={classes.rating}>
                    <span> {rating}</span>
                </div>
            </div>
            <div className={classes.secondHalf}>
                <div className={classes.smiles}>
                    <div>{positive}</div>
                    <div>{neutral}</div>
                    <div>{negative}</div>
                </div>
                <div className={classes.reviews}>{reviews}</div>
                <div className={classes.comments}>{comments}</div>
            </div>
            <div className={classes.button}>
                {button}
            </div>
        </div>
    );
};

RowRating.defaultProps = {
    pos: 0,
    name: "",
    rating: 0 || "",
    positive: 0,
    neutral: 0,
    negative: 0,
    reviews: 0,
    comments: 0,
};

RowRating.propTypes = {
    pos: PropTypes.number.isRequired,
    name: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
    rating: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
        .isRequired,
    positive: PropTypes.number.isRequired,
    neutral: PropTypes.number.isRequired,
    negative: PropTypes.number.isRequired,
    reviews: PropTypes.number.isRequired,
    comments: PropTypes.number.isRequired,
};
export default setDisplayName("RowRating")(withStyles(styles)(RowRating));
